import React from 'react';
import classNames from 'classnames';

export default ({
    header,
    posts,
}) => (
        <div className="featured-media grid-container contained mt5 mb5 mb2--md">
            <div className="row align--center">
                <div className="col c12--sm">
                    <h1 className="mt12--lg domaine--large tc mb2 mb10--md">
                        {header}
                    </h1>
                </div>
            </div>
            <div className="featured-media__posts">
                <div>
                    <a href={'/blog/' + posts[0].post.slug.current + '/'}>
                        <div className="featured-media__post featured-media__post--1" style={{ backgroundImage: `url(${posts[0].post.featuredImage.url}?w=1200&auto=format&q=75)` }}>
                            <div>
                                <span className="db color--white fw--700 uppercase sans--small mb1">Featured Post</span>
                                <h4 className="color--white domaine--medium-large">{posts[0].post.title}</h4>
                            </div>
                        </div>
                    </a>
                </div>
                <div>
                    <div className="posts-vertical">
                        <div className="featured-media__post featured-media__post--2" style={{ backgroundImage: `url(${posts[1].post.featuredImage.url}?w=1200&auto=format&q=75)` }} />
                        <div className="post-content post-content--1 bg--gray-bg">
                            <span className="db fw--700 uppercase sans--small mb1">Featured Post</span>
                            <h4 className="domaine--medium">{posts[1].post.title}</h4>
                            <button
	name="add"
	type="button"
	onClick={() => location.href='/blog/' + posts[1].post.slug.current + '/'}
	className={classNames('full-width button--primary-black')}>
                                View Full Post
                            </button>
                        </div>
                    </div>
                    <div className="posts-vertical posts-vertical--2">
                        <div className="featured-media__post featured-media__post--3 image" style={{ backgroundImage: `url(${posts[2].post.featuredImage.url}?w=1200&auto=format&q=75)` }} />
                        <div className="post-content post-content--2 align--center bg--gray-bg">
                            <span className="db fw--700 uppercase sans--small mb1">Featured Post</span>
                            <h4 className="domaine--medium">{posts[2].post.title}</h4>
                            <button
	name="add"
	type="button"
	onClick={() => location.href='/blog/' + posts[2].post.slug.current + '/'}
	className={classNames('full-width button--primary-black')}>
                                View Full Post
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );